// import { request } from '@/utils'
import flat from './flat'
import { SHOP_ID } from '@/utils/const'
import { cartUrl } from './const'

const baseUrl = 'https://learn.baicizhan.com/api/mall/proxy/cart'

export function getCartData(shopId, activityIds) {
  const act = activityIds ? `&activityIds=${activityIds}` : ''
  return flat(`${baseUrl}/get_cart_list?shopId=${shopId}${act}`)
}

//修改数量
/**
 * 修改数量
 * @param {object} param
 * @param {number} param.subItemId
 * @param {number} param.count
 * @param {number} param.shopId
 * @param {boolean} param.choice
 * @returns
 */
export function updateNumber(param) {
  // return flat(`${baseUrl}/modify_goods`)
  return flat(`${baseUrl}/modify_goods?choice=${param.choice || false}`, {
    method: 'POST',
    body: {
      ...param,
    },
  })
}

/**
 * 获取活动id(获取换购活动的id)
 * @returns
 */
export function getActivityIds() {
  return flat(`${baseUrl}/get_activity_id`)
}

/**
 * 修改选中状态
 * @param {object} param
 * @param {Array[number]} param.subItemIds
 * @param {boolean} param.newStatus
 * @param {number} param.shopId
 * @returns
 */
export function updateSelected(param) {
  const { newStatus, subItemIds, shopId } = param
  const url = newStatus ? '/choice_goods' : '/cancel_choice_goods'
  // return flat(`${baseUrl}${url}`)
  return flat(`${baseUrl}${url}`, {
    method: 'POST',
    body: {
      shopId: shopId,
      subItemIds,
    },
  })
}

/**
 * 删除商品
 * @param {object} param
 * @param {array} param.subItemIds
 * @param {number} param.shopId
 * @returns
 */
export function delItem(param) {
  return flat(`${baseUrl}/remove_goods`, {
    method: 'POST',
    body: {
      ...param,
    },
  })
}

/**
 * 修改sku
 * @param {object} param
 * @param {number} param.oldSubItemId
 * @param {number} param.targetSubItemId
 * @param {number} param.shopId
 * @returns {Promise}
 */
export function changeSku(param) {
  return flat(`${baseUrl}/change_sku`, {
    method: 'POST',
    body: {
      ...param,
    },
  })
}

/**
 * 获得通知消息
 * @returns
 */
export function getNotify() {
  return flat(`${baseUrl}/get_notify`)
}
/**
 *
 * @param {object} param
 * @param {number} param.activityId
 * @param {number} param.shopId
 * @param {number} param.subItemId
 * @param {number} param.count
 * @returns
 */
export function modifyActGoods(param) {
  // activityId, (shopid = SHOP_ID)
  const { activityId, shopId = SHOP_ID, ...ot } = param
  return flat(`${cartUrl}/activity_modify_goods`, {
    method: 'POST',
    body: {
      ...ot,
      count: 1,
      activityId,
      shopId,
    },
  })
}

/**
 * 删除活动购物车商品
 * @param {object} param
 * @param {number} param.activityId
 * @param {number} param.shopId
 * @param {Array<number>} param.subItemIds
 * @returns
 */
export function removeActGoods(param) {
  const { activityId, shopId = SHOP_ID, ...ot } = param

  return flat(`${cartUrl}/activity_remove_goods`, {
    method: 'POST',
    body: {
      ...ot,
      activityId,
      shopId,
    },
  })
}
